export function format(value, type) {
  if (type === "percentage") {
    return Math.round(value * 1000000) / 10000 + "%";
  }
  return parseFloat(value).toLocaleString("de-CH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
